import React, { useState } from "react";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import Translator from "Languages/Utility/Translator";
import { Dialog, DialogActions, DialogContent, Grid } from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";
import * as Icons from "react-bootstrap-icons";
import { read } from "Helpers/LocalStorage";
import { useTranslation } from "react-i18next";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import showNotify from "Helpers/Notify";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import PeriodDetailsHistory from "./components/periodDetailsHistory";
import PeriodDetailsPayments from "./components/periodDetailsPayments";
import PeriodDetailsShow from "./components/PeriodDetailsShow";
import { useTheme } from "@material-ui/core/styles";
import DialogHead from "Components/DialogHead/DialogHead";

export default function PeriodDetails({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const onShowDialog = () => {
    setShowDialog(true);
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Id: row.Id,
      };
      const response = await AccountService.getAccountGroupHistoryDetails(
        params
      );
      //   console.log(response);
      let err = StatusHandler(response);
      if (!err.isFail) {
        setData(response.data.Value);
      }
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (e) {
      showNotify({ text: "getDataError", customClass: "error" });
      setShowDialog(false);
    }
  };

  const onExit = () => {
    setShowDialog(false);
  };

  return (
    <>
      <ActionFormatter
        title={<Translator id="period_details" />}
        icon={<Icons.ClipboardData />}
        onClick={onShowDialog}
        className="primary-button"
      />
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{ onEnter: onEnter, onExit: onExit }}
        fullWidth
        maxWidth="lg"
      >
        <DialogHead
          text={
            <>
              <Translator id="period_details" />
              <strong> - {row.Period} - </strong>
            </>
          }
          subtext={row.GroupName}
          icon={<Icons.ClipboardData />}
        />
        <DialogContent className="p-0 py-2">
          <PeriodDetailsShow data={data} />
          {!loading ? (
            <TabContext value={value}>
              <TabList onChange={handleChange} className="dialog-tab">
                <Tab
                  label={
                    <span>
                      <Icons.CreditCard2Front size={17} />{" "}
                      {t("sapg_periodsCharge")}
                    </span>
                  }
                  value="1"
                />
                <Tab
                  label={
                    <span>
                      <Icons.CashStack size={17} /> {t("sapg_periodsPay")}
                    </span>
                  }
                  value="2"
                />
              </TabList>

              <TabPanel value="1" className="p-0 m-0 ">
                <PeriodDetailsHistory data={data.Items} />
              </TabPanel>

              <TabPanel value="2" className="p-0 m-0 ">
                <PeriodDetailsPayments data={data.Payments} />
              </TabPanel>
            </TabContext>
          ) : (
            <InnerCircularProgress />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            onClick={() => setShowDialog(false)}
            title={<Translator id="close" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
